import axios from "axios";
import { APIExperience, ECOMMERCE_URL } from "../config/constants";

const isEnrolled = async (id, session) => {
  return await axios
    .get(`${APIExperience}/api/enrollment/v1/enrollment`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${session.access_token}`,
      },
    })
    .then((res) => {
      return !!res.data.find((enrollment) => {
        return enrollment.course_details.course_id === id;
      });
    })
    .catch((err) => console.log({ err }));
};

export const handleEnrollement = (course, session, navigate) => {
  isEnrolled(course.course_id, session).then((enrolled) => {
    if (!enrolled) {
      axios
        .post(
          `${APIExperience}/api/enrollment/v1/enrollment`,
          {
            user: session.username,
            course_details: { course_id: course.course_id ? course.course_id : course.modes[0].course_id },
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `bearer ${session.access_token}`,
            },
          }
        )
        .then(function (response) {
          navigate("/Mycourses");
        })
        .catch(function (error) {
          if (Object.keys(session).length > 0)
            if (course.modes && course?.modes[0]?.sku)
              window.location.href = `${ECOMMERCE_URL}/basket/add/?sku=${course?.modes[0]?.sku}`;
            else
              navigate(
                `/signin?redirect=/details/${course.course_id
                  ? course.course_id
                  : course.modes[0].course_id
                }`
              );
          else if (
            course.modes &&
            course?.modes[0]?.sku &&
            course?.modes[0]?.min_price > 0
          )
            navigate(
              `/signin?redirect=${ECOMMERCE_URL}/basket/add/?sku=${course?.modes[0]?.sku}`
            );
          else
            navigate(
              `/signin?redirect=/details/${course.course_id ? course.course_id : course.modes[0].course_id
              }`
            );
        });
    } else {
      window.location.href = `https://apps.experience.eyouthlearning.com/learning/course/${course.course_id}/home`
    }
  });
};
